import { LinkButton } from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import { Button } from '@windmill/react-ui';
import { useCallback, useState } from 'react';
import OtpInput from 'react-otp-input';

interface VerifyOTPOptions {
  prompt?: string;
  actionTitle?: string;
  resendTitle?: string;
  onVerifyPressed: (code: string) => Promise<void> | void;
  onResendPressed: () => Promise<void> | void;
  length?: number;
  className?: string;
}

export const VerifyOTPCard = ({
  className = '',
  prompt = 'Enter OTP',
  actionTitle = 'Verify',
  resendTitle = 'Resend OTP',
  length = 6,
  onVerifyPressed,
  onResendPressed,
}: VerifyOTPOptions) => {
  const [code, setCode] = useState<string>('');

  const onOtpChanged = useCallback(
    (value: string) => {
      setCode(value);
    },
    [setCode]
  );

  const onVerify = useCallback(() => {
    if (code) {
      onVerifyPressed(code);
    }
  }, [code, onVerifyPressed]);

  return (
    <div className={className}>
      <div className="flex flex-col justify-center items-center flex-1 w-full">
        <div className="font-medium">{prompt}</div>
        <div className="mt-5 mb-5">
          <OtpInput
            inputStyle={{
              marginLeft: 5,
              marginRight: 5,
              backgroudColor: '#E0E3EB',
              border: '1px solid #E0E3EB',
              borderRadius: 6,
              minWidth: 42,
            }}
            numInputs={length}
            onChange={onOtpChanged}
            placeholder={'X'.repeat(length)}
            value={code}
          />
        </div>
        <div className="flex flex-col justify-center">
          <Button className="w-110 h-12" onClick={onVerify}>
            {actionTitle}
          </Button>
        </div>
        <LinkButton
          className="my-os1-spacing"
          linkText={resendTitle}
          onClick={onResendPressed}
        />
        <div className="mb-5">
          OTPs may be requested once every 30 seconds and expire after 10
          minutes.
        </div>
      </div>
    </div>
  );
};
